<template>
  <UiContentwrapper>
    <UiFullcolumn class="mb-1">
      <h2>Everything you need included</h2>      
    </UiFullcolumn>

    <template v-if="filteredArticles.length">
      <div class="col-span-5"
        v-for="(article, index) in filteredArticles"
        :key="article.id"
      >
        <UiArticleImage
          v-if="article.image && article.handle !== 'wheelset-image'"
          :fit="'crop'"
          :modifiers="{ auto: 'format,compress', ar: '1:1' }"
          :article="article"
        />
        <UiArticleImage
          v-else
          :fit="'crop'"
          class="bg-gravaasuperlightwarmgray"
          :modifiers="{ auto: 'format,compress', ar: '1:1' }"
          :article="{ title: product.title, image: product.featuredImage?.url}"
        />
        <div class="mt-2" v-html="article.contenthtml" />
      </div>
    </template>

    <div v-else class="col-span-5">
      <p>No included articles found.</p>
    </div>
  </UiContentwrapper>
</template>

<script setup>
import { computed } from 'vue';
import { useBlogStore } from '@/stores/blogStore';

const blogStore = useBlogStore();

defineProps({
  product: {
    type: Object,
    required: true
  }
});

await callOnce('pdpBlog', async () => {
  await blogStore.fetchBlogByHandle('pdpblog')
})

const pdpBlog = computed(() => blogStore.blogsByHandle.pdpblog)

// Filter to only articles with the tag "included"
const filteredArticles = computed(() => {
  if (!pdpBlog.value?.articles) return []
  return pdpBlog.value.articles.filter(
    article => article.tags && article.tags.includes('Included')
  )
})
</script>
